/** @format */

import {Box, Typography, Button} from '@mui/material';
import {styled} from '@mui/material/styles';

export const TooltipContentContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  background: theme.palette.semantic_light?.surface.background,
  color: theme.palette.semantic_light?.surface.onSurface,
  maxWidth: '680px',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const TooltipTitle = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.surface.onSurface,
  width: '300px',
}));

export const ButtonGroupWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const ButtonGroupBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
}));

export const ButtonsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: '1px',
  alignItems: 'center',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.semantic_light?.surface.surface2}`,
  overflow: 'hidden',
  color: theme.palette.semantic_light?.surface.onSurfaceMuted,
}));

export const IconWrapper = styled(Box)(({theme}) => ({
  margin: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.semantic_light?.surface.onSurfaceMuted,
}));

export const TooltipButton = styled(Button)(({theme}) => ({
  padding: theme.spacing(4),
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  backgroundColor: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,
  borderRadius: 0,
  '&:first-of-type': {
    borderTopLeftRadius: theme.spacing(2),
    borderBottomLeftRadius: theme.spacing(2),
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.semantic_light?.disabled.disabledLow,
    color: theme.palette.semantic_light?.disabled.disabled,
  },
}));

export const DescriptionText = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_light?.surface.onSurface,
  flex: 1,
}));

